// ============================================================
// Editable homepage content constants.
// Keep copy/config here so non-structural tweaks don't touch JSX.
// ============================================================

import heroImage from '../../assets/hero-home.jpg';

// Hero background photo. Swap this import (or replace the file in src/assets)
// to change the hero image — the mare-and-foal photo vendored from the prior
// hosted landing-page.json asset.
export const HERO_IMAGE = heroImage;

// Typewriter words cycled in the hero headline: "Find your ___ horse."
// Purely visual. Edit/reorder freely.
export const TYPEWRITER_WORDS = [
  'barrel',
  'cutting',
  'reining',
  'roping',
  'premier',
];

// Trust-line listing count — FALLBACK for the live count. The hero fetches the
// real cumulative count from tph-api (/api/v1/public/stats/horse-count via the
// same-origin /api/horse-count proxy; see ./horseCount.js) and shows this
// static value only while the fetch is pending or when it fails.
export const HORSE_COUNT = '3,000+';

// Search placeholder shared by the hero pill and the homepage docked search
// bar (desktop). Single source — do not duplicate this literal.
export const HERO_SEARCH_PLACEHOLDER = 'Try a name, sire, or "barrel horse under $40k"';
